// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Alert from "src/components/shared/alerts/Alert/Alert";

type ExternalExamIframeType = {
  examUrl: string | null | undefined;
  height?: string;
  hideToolbar?: boolean;
  zoom?: number;
};

const ExternalExamIframe = ({
  examUrl,
  height = "1000px",
  hideToolbar = false,
  zoom,
}: ExternalExamIframeType) => {
  const { t } = useTranslation();

  if (!examUrl) {
    return (
      <Alert variant="error" alertContent={t("No Exam File Available.")} />
    );
  }

  const isPng = examUrl.toLowerCase().includes("png");

  if (isPng) {
    return (
      <img
        src={examUrl}
        alt={t("Exam File")}
        style={{ width: "100%", height: "auto", display: "block" }}
      />
    );
  }

  const pdfViewerParams = [
    hideToolbar ? "toolbar=0&navpanes=0" : "navpanes=0",
    zoom ? `zoom=${zoom}` : null,
  ]
    .filter(Boolean)
    .join("&");

  return (
    <iframe
      // A new key forces the iframe to reload
      key={pdfViewerParams}
      src={`${examUrl}#${pdfViewerParams}`}
      width="100%"
      height={height}
      style={{ border: "none" }}
      title={t("Exam File")}
    />
  );
};

export default ExternalExamIframe;
